/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles.Tile.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.OptionTiles.Tile.Collection", ["require", "exports", "underscore", "SuiteCommerce.GiftCertificate.Common.Utils", "SuiteCommerce.GiftCertificate.Common.DependencyProvider", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration", "SuiteCommerce.GiftCertificate.OptionTiles.Tile.Model"], function (require, exports, _, Utils_1, DependencyProvider_1, OptionTiles_Configuration_1, OptionTiles_Tile_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TileCollection = void 0;
    var TileCollection = /** @class */ (function (_super) {
        __extends(TileCollection, _super);
        function TileCollection(options) {
            var _this = _super.call(this) || this;
            _this.environment = options.environment;
            _this.filters = options.filters;
            _this.url = _this.getUrl();
            _this.model = OptionTiles_Tile_Model_1.TileModel;
            _this.comparator = function (model) {
                return model.price;
            };
            return _this;
        }
        TileCollection.prototype.getUrl = function () {
            return Utils_1.Utils.addParamsToUrl('/api/items', this.getSearchApiParams());
        };
        TileCollection.prototype.getSearchApiParams = function () {
            return _({}).extend(OptionTiles_Configuration_1.OptionTilesConfiguration.searchApiMasterOptions.itemDetails, this.getSessionSearchApiParams(), this.getItemsParams());
        };
        TileCollection.prototype.getSessionSearchApiParams = function () {
            var searchApiParams = {};
            var sessionInfo = this.environment
                ? this.environment.getSession()
                : null;
            var locale = '';
            var currency = '';
            var priceLevel = '';
            if (sessionInfo) {
                locale = sessionInfo.language && sessionInfo.language.locale;
                currency = sessionInfo.currency && sessionInfo.currency.code;
                priceLevel = sessionInfo.priceLevel;
            }
            var localeTokens;
            var language;
            var country;
            if (locale.indexOf('_') >= 0) {
                localeTokens = locale.split('_');
                language = localeTokens[0];
                country = localeTokens[1];
            }
            else {
                language = locale;
            }
            // SET API PARAMS
            if (language) {
                searchApiParams.language = language;
            }
            if (country) {
                searchApiParams.country = country;
            }
            if (currency) {
                searchApiParams.currency = currency;
            }
            searchApiParams.pricelevel = priceLevel;
            // No cache
            if (Utils_1.Utils.parseUrlOptions(window.location.search).nocache === 'T') {
                searchApiParams.nocache = 'T';
            }
            searchApiParams.limit = 100;
            return searchApiParams;
        };
        TileCollection.prototype.getItemsParams = function () {
            return this.filters;
        };
        TileCollection.prototype.parse = function (response) {
            return _(response.items).compact() || null;
        };
        return TileCollection;
    }(DependencyProvider_1.BackboneCachedCollection));
    exports.TileCollection = TileCollection;
});
